import { render, staticRenderFns } from "./PhoneCheck.vue?vue&type=template&id=e0536dda&lang=html"
import script from "./PhoneCheck.vue?vue&type=script&lang=js"
export * from "./PhoneCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports